export default function carCategories() {

    const carCategoriesItems = document.querySelectorAll('#sliderCarModel-2 .car-category__content')
  
    if (carCategoriesItems.length === 0) return
  
    carCategoriesItems.forEach(item => {
      item.addEventListener('pointerover', onPointerover)
      item.addEventListener('pointerout', onPointerout)
    })
  
    function onPointerover(e) {
      const targetItem = e.target.closest('.car-category__content')
  
      for (const item of carCategoriesItems) {
        if (item === targetItem) {
          item.classList.add('active')
        }
        else {
          item.classList.remove('active')
          item.classList.add('inactive')
        }
      }
  
    }
  
    function onPointerout(e) {
      for (const item of carCategoriesItems) {
        item.classList.remove('active')
        item.classList.remove('inactive')
      }
    }
  }